var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFizyka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subject-fizyka-1{fill:#464af0;}.subject-fizyka-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fizyka") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4077",
    "data-name": "Group 4077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M28.48,37.33a4.44,4.44,0,1,1,4.44-4.44A4.44,4.44,0,0,1,28.48,37.33Zm0-7.38a2.95,2.95,0,1,0,2.95,2.94A2.94,2.94,0,0,0,28.48,30Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4072",
    "data-name": "Group 4072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M21.1,37.33a4.44,4.44,0,1,1,4.44-4.44A4.45,4.45,0,0,1,21.1,37.33Zm0-7.38A2.95,2.95,0,1,0,24,32.89,2.95,2.95,0,0,0,21.1,30Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4073",
    "data-name": "Group 4073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M11.86,34.86a4.44,4.44,0,1,1,4.44-4.44A4.44,4.44,0,0,1,11.86,34.86Zm0-7.39a2.95,2.95,0,1,0,3,3A3,3,0,0,0,11.86,27.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3409",
    "data-name": "Path 3409"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M13.71,27.59a.34.34,0,0,1-.19-.05.36.36,0,0,1-.13-.51l7.38-12.79a.37.37,0,1,1,.65.37L14,27.41A.36.36,0,0,1,13.71,27.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_18",
    "data-name": "Line 18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M28.48,29.57a.36.36,0,0,1-.37-.37V14.43a.37.37,0,0,1,.37-.38.38.38,0,0,1,.38.38V29.2A.37.37,0,0,1,28.48,29.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M35.87,37.33a4.44,4.44,0,1,1,4.44-4.44A4.44,4.44,0,0,1,35.87,37.33Zm0-7.38a2.95,2.95,0,1,0,2.94,2.94A2.95,2.95,0,0,0,35.87,30Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_19",
    "data-name": "Line 19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M35.87,29.57a.37.37,0,0,1-.38-.37V14.43a.38.38,0,1,1,.75,0V29.2A.37.37,0,0,1,35.87,29.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M21.1,29.57a.37.37,0,0,1-.38-.37V14.43a.38.38,0,1,1,.75,0V29.2A.37.37,0,0,1,21.1,29.57Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "subject-fizyka-2",
    x1: 35.87,
    y1: 14.43,
    x2: 21.1,
    y2: 14.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "subject-fizyka-2",
    d: "M35.87,15.18H21.1a.75.75,0,0,1,0-1.5H35.87a.75.75,0,0,1,0,1.5Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFizyka);
export default __webpack_public_path__ + "static/media/fizyka.f8863bcd9d837a2673e20ec616e80c1e.svg";
export { ForwardRef as ReactComponent };